import CircularLoader from "@/components/loading/LoadingComponent";
import { AuthContext } from "@/contexts/AuthContext";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface GuardProps {
    children: React.ReactNode;
}

const AuthGuard = ({ children }: GuardProps) => {
    const { isAuthenticated, loading } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (!loading && !isAuthenticated) {
            navigate("/");
        }
    }, [isAuthenticated, loading, navigate]);

    if (loading) {
        return <CircularLoader />;
    }

    return isAuthenticated ? <>{children}</> : null;
};

export default AuthGuard;
